module.exports = __webpack_public_path__ + "img/section2Bg1M.eeeb3652.webp";